import React from 'react';
import { Container } from 'react-bootstrap';
import Section from './Section';
import ProjectsLite from './ProjectsLite';

const ProjectsSection = () => (
  <Section id="projects" className="section-dark">
    <Container>
      <h2 className="section-title text-center">Projects</h2>
      <ProjectsLite />
    </Container>
  </Section>
);

export default ProjectsSection;
